/* eslint-disable no-console */
import { inject } from "mobx-react";

import type { AssetInterface } from "@ihr-radioedit/inferno-core";
import type { BaseStore } from "@inferno/renderer-shared-core";
import { slugify } from "@ihr-radioedit/inferno-core";
import AssetCaption from "./AssetCaption.component";
import "./MediaAsset.style.scss";
import type { Store } from "@inferno/renderer-shared-core";

export interface MediaAssetProps extends AssetInterface {
  store?: Store | BaseStore;
}

export const MediaAsset = inject("store")((props: MediaAssetProps) => {
  const imageHost = props.store?.env?.NATIONAL_SITE_URL || "";
  const params = new URLSearchParams();
  params.set("reid", `${props.bucket}${props.id}`);
  params.set("embed", "true");
  params.set("autoStart", "false");
  params.set("useFullScreen", "true");
  const title = props.title ? props.title : "no title";
  const url = `${imageHost}/video/${slugify(title)}/?${params.toString()}`;

  return (
    <>
      <div className="embed-responsive embed-responsive-16by9 media-asset">
        <iframe
          title={`${title || "Media Embed"}`}
          allowFullScreen={true}
          className="embed-responsive-item"
          frameBorder={0}
          scrolling="no"
          src={url}
        />
      </div>
      <AssetCaption {...props} assetType="Media" />
    </>
  );
});

export default MediaAsset;
